import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {handleCallback} from "./authService";

const Callback = () => {
    const navigate = useNavigate();

    useEffect(() => {
        console.log("Handling callback...");
        handleCallback()
            .then(() => {
                navigate("/");
            })
            .catch(error => {
                console.error("Erreur lors du callback:", error);
                // Éventuellement naviguer vers une page d'erreur
            });
    }, [navigate]);


    return <div>Authentification en cours...</div>;
};

export default Callback;
